import { useState } from "react";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import PageHeader from "../../../components/pageHeader/pageHeader";
import style from "../../../components/FieldSequence/FieldSequence.module.css";
import FieldSequenceToggle from "../../../components/FieldSequence/FieldSequenceToggle";
import FieldSequenceEditor from "../../../components/FieldSequence/FieldSequenceEditor";

/**
 * Admin screen of the Field Sequence feature: switch the applicant form, and
 * separately the review screens' application details, between the default
 * order of the fields and the order set here, and edit that order. The
 * screen only lays the parts out; each switch is a FieldSequenceToggle and
 * the list is FieldSequenceEditor.
 */
export default function FieldSequence() {
  /** The header needs a search value even though this screen has no search. */
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div>
      <div className={style.bodyBox}>
        <PageHeader
          title="Field Sequence"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={false}
          showAdditionalButton={false}
          buttonTitle=""
          showGridButton={false}
          showFilterButton={false}
        />

        <p className={style.sectionTitle}>
          {/* BEFORE - "The order in which the applicant form lists its fields" */}
          The order in which the applicant's screens and the reviewers' screens
          list the application's fields
        </p>
        <BoxComponent>
          <div className={style.settingRow}>
            <div className={style.settingText}>
              {/* BEFORE - "Show fields in the sequence set below", with the hint
                  "When on, the applicant form follows the sequence saved
                  below. ..."; renamed so it reads apart from the reviewers'
                  switch under it, and the applicant's View Application now
                  follows this switch too. */}
              <p className={style.settingName}>
                Applicant form and the applicant's View Application
              </p>
              {/* BEFORE - the hint named only the applicant form and View
                  Application; the payment details screen and the resubmit
                  preview follow this switch too. */}
              <p className={style.settingHint}>
                When on, the applicant form, the applicant's View Application,
                their Payment details screen and the Resubmit preview follow
                the sequence saved below. When off, they use the default order.
                On the form, fields stay on their own form step and the
                sequence orders them within each step. Empty spaces show only
                on the application form, not on the other screens.
              </p>
            </div>
            <FieldSequenceToggle target="form" />
          </div>
          {/* The reviewers' screens have their own switch, apart from the
              applicant's; both follow the one sequence saved below. */}
          <div className={style.settingRow}>
            <div className={style.settingText}>
              <p className={style.settingName}>
                L1/L2/L3 and Admin/reviewer View Application
              </p>
              <p className={style.settingHint}>
                When on, the application details on the Level 1, Level 2 and
                Level 3 screens, the Admin/reviewer View Application and their
                downloaded PDF follow the sequence saved below, as one list.
                Empty spaces are not shown there; they apply only to the
                application form. Details not in the sequence follow after.
                When off, they use the default order.
              </p>
            </div>
            <FieldSequenceToggle target="review" />
          </div>
        </BoxComponent>

        <p className={style.sectionTitle}>Sequence</p>
        <BoxComponent>
          <FieldSequenceEditor />
        </BoxComponent>
      </div>
    </div>
  );
}
